import React from 'react'
import { useNavigate } from 'react-router-dom'
import IconVectorLeft from '../../../../assets/icons/vectorLeft.svg'
import IconRuleta from '../../../../assets/icons/icons-bloques/ruleta.svg'

const ActividadesHeader = ({renglonesLength, actIcon, title}) =>{

    const navigate = useNavigate()
    return(
        <>
            <div className="bg-[#bac4d9] grid-cols-12 h-24 grid justify-between items-center relative">
            <div className="col-span-10 flex items-center ">
                <button onClick={()=>{navigate(-1)}} className="flex items-center text-nimbus mx-10">
                    <img src={IconVectorLeft} alt="" className='w-5 h-5'/>
                    <span className="ml-2 hover:brightness-110 transition">Regresar</span>
                </button>
                {/* <input className="bg-white border-1 border-[#dcdcdc] border rounded w-64 py-3 h-min mr-5" type="text" placeholder="Nombre"/>
                <input className="mr-2 checked:bg-[#18BAFB] border-2 border-gray-500" type="checkbox" id="" value="" checked/> 
                <label class="form-check-label inline-block text-gray-800 mr-5 " for="flexCheckDefault" >
                Evaluable 
                </label> */}
                <span className='flex items-center'>
                    <img src={actIcon} className="w-[4rem] h-[4rem] rounded-lg shadow-lg bg-white mr-3 p-1" alt=''/>
                    <div className='w-[175px] text-xl text-white'>{title}</div>
                </span>
            </div>
            <div>
                <div className="col-span-2  flex gap-2 items-center absolute top-1/2 transform -translate-y-1/2 right-[270px]">
                    <p className="font-medium text-nimbus text-sm">Renglones</p>
                    <div className="bg-[#18BAFB] rounded-full h-6 w-6 p-4 flex justify-center items-center">
                        <span className="text-sm font-medium text-white">{renglonesLength}</span>
                    </div>
                </div>
            </div>
            </div>
        </>
    )
}

export default ActividadesHeader